import React from 'react';
import { formatAppDateTime } from '../../utils/appDateTime';

const ShiftDetailsModal = ({ open, onClose, data }) => {
  if (!open) return null;
  const { shift, notes, attendance } = data || {};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl h-[80vh] p-6 relative overflow-auto">
        <button onClick={onClose} className="absolute top-3 right-3 text-[#DC1F00] p-2">✖</button>
        <h2 className="text-xl font-semibold mb-4">Shift Details</h2>
        {!shift && <div>No shift data</div>}
        {shift && (
          <div className="space-y-4">
            <div>
              <div className="text-sm text-gray-500">Job</div>
              <div className="font-medium">{shift.job_title || shift.job || '—'}</div>
            </div>
            <div>
              <div className="text-sm text-gray-500">Client</div>
              <div className="font-medium">{shift.client_name || shift.client || '—'}</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <div className="text-sm text-gray-500">Start</div>
                <div className="font-medium">{formatAppDateTime(shift.start_date)}</div>
              </div>
              <div>
                <div className="text-sm text-gray-500">End</div>
                <div className="font-medium">{formatAppDateTime(shift.end_date)}</div>
              </div>
            </div>

            <div>
              <div className="text-sm text-gray-500">Location</div>
              <div className="font-medium">{shift.location || shift.address || '—'}</div>
            </div>

            <div>
              <div className="text-sm text-gray-500">Notes / Issues</div>
              <div className="mt-2 space-y-2">
                {notes && notes.length > 0 ? notes.map(n => (
                  <div key={n.note_id} className="p-2 border rounded bg-gray-50">
                    <div className="text-xs text-gray-500">{formatAppDateTime(n.create_date)} — Account {n.account_id}</div>
                    <div className="text-sm">{n.note}</div>
                  </div>
                )) : <div className="text-sm text-gray-500">No notes</div>}
              </div>
            </div>

            <div>
              <div className="text-sm text-gray-500">Attendance</div>
              <div className="mt-2 space-y-2">
                {attendance && attendance.length > 0 ? attendance.map(a => (
                  <div key={a.id} className="p-2 border rounded bg-gray-50">
                    <div className="text-xs text-gray-500">{formatAppDateTime(a.timestamp)} — Account {a.account_id} — {a.event_type}</div>
                    {a.note && <div className="text-sm">{a.note}</div>}
                  </div>
                )) : <div className="text-sm text-gray-500">No attendance recorded</div>}
              </div>
            </div>

            <div className="mt-4 flex justify-end gap-2">
              <button onClick={onClose} className="px-4 py-2 border rounded">Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShiftDetailsModal;
